import { Avatar, Tooltip } from "@mui/material"
import { UserHelper } from "../../models/UserHelper"
import { profilePhotoUrl, UserInfo } from '../../models/UserInfo'
import { resizedImageUrl } from "../../util/resizedImageUrl"

interface Props {
  userInfo: UserInfo
  withTooltip?: boolean
  size?: string
  color?: string
}

export default function UserAvatar({ userInfo, withTooltip, size, color }: Props) {
  const user = new UserHelper(userInfo)

  const avatar =
        <Avatar id="user-avatar"
          src={resizedImageUrl(profilePhotoUrl(userInfo), 120)}
          alt={user.displayName()}
          style={{ width: size, height: size, }}
          color={color}
        >
          {user.abbrev()}
        </Avatar>

  if (!withTooltip || !user.isComplete()) return avatar

  return (
    <Tooltip title={user.displayName()} arrow>
      { avatar }
    </Tooltip>
  )
}
